import * as Actions from './constants'

const getStored = (key, defaultValue = null) => {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  } catch (err) {
    return defaultValue;
  }
};

const initState = {
  magazineData: [],
  magazineFavData: [],
  magazineLikeData: [],
  yearsData: [],
  blogFeatureData: [],
  purchasedCourseData: [],
  likeCourseData: [],
  technicalCategoryData: [],
  technicalsByCategoryData: {},
  courseCategoryData: [],
  courseTeacherData: [],
  technicalDetailData: null,
  technologyDetailListData: [],
  onlineClassDetailData: [],
  onlineClassRelatedData: [],
  productData: [],
  productCategoryData: [{ _id: 'ALL', name: '全部' }],
  productFeaturedData: [],
  productDetailData: null,
  productBanners: [],
  educationBanners: [],
  adsData: []
}

export default function dataWebsiteReducer(state = initState, action = {}) {
  switch (action.type) {
    case Actions.MAGAZINE_DATA_GET:
      return {
        ...state,
        magazineData: action.payload,
      }
    case Actions.MAGAZINE_FAV_DATA_GET:
      return {
        ...state,
        magazineFavData: action.payload,
      }
    case Actions.MAGAZINE_LIKE_DATA_GET:
      return {
        ...state,
        magazineLikeData: action.payload,
      }
    case Actions.PRODUCT_BANNERS_GET:
      return {
        ...state,
        productBanners: action.payload,
      }
    case Actions.EDUCATION_BANNERS_GET:
      return {
        ...state,
        educationBanners: action.payload,
      }
    case Actions.ADS_DATA_GET:
      return {
        ...state,
        adsData: action.payload,
      }
    case Actions.YEAR_DATA_GET:
      return {
        ...state,
        yearsData: action.payload,
      }
    case Actions.BLOG_FEATURE_DATA_GET:
      return {
        ...state,
        blogFeatureData: action.payload,
      }
    case Actions.PURCHASED_COURSE_DATA_GET:
      return {
        ...state,
        purchasedCourseData: action.payload,
      }
    case Actions.LIKE_COURSE_DATA_GET:
      return {
        ...state,
        likeCourseData: action.payload,
      }
    case Actions.EDUCATION_TECHNICAL_CATEGORY_GET:
      return { ...state, technicalCategoryData: action.payload }
    case Actions.EDUCATION_TECHNICALS_BY_CATEGORY_GET:
      return { ...state, technicalsByCategoryData: action.payload }
    case Actions.EDUCATION_COURSE_CATEGORY_GET:
      return { ...state, courseCategoryData: action.payload }
    case Actions.EDUCATION_TEACHERS_GET:
      return { ...state, courseTeacherData: action.payload }
    case Actions.TECHNICAL_DETAIL_GET:
      return { ...state, technicalDetailData: action.payload }
    case Actions.TECHNOLOGY_DETAIL_LIST_GET:
      return { ...state, technologyDetailListData: action.payload }
    case Actions.ONLINE_CLASS_DETAIL_GET:
      return { ...state, onlineClassDetailData: action.payload }
    case Actions.ONLINE_CLASS_RELATED_GET:
      return {
        ...state,
        onlineClassRelatedData: action.payload,
      };
    case Actions.PRODUCT_DATA_GET:
      return {
        ...state,
        productData: action.payload,
      };
    case Actions.PRODUCT_CATEGORY_GET:
      return {
        ...state,
        productCategoryData: action.payload,
      };
    case Actions.PRODUCT_FEATURED_GET:
      return {
        ...state,
        productFeaturedData: action.payload,
      };
    case Actions.PRODUCT_DETAIL_GET:
      return {
        ...state,
        productDetailData: action.payload,
      };
    default:
      return state;
  }
}
